import { render, staticRenderFns } from "./NetChildren.vue?vue&type=template&id=8bf9a7de&scoped=true&"
import script from "./NetChildren.vue?vue&type=script&lang=js&"
export * from "./NetChildren.vue?vue&type=script&lang=js&"
import style0 from "./NetChildren.vue?vue&type=style&index=0&id=8bf9a7de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf9a7de",
  null
  
)

export default component.exports